// Shared period filter for the Operations-page charts (activity hero, op-days
// trend, treatment-income dashboard). One set of options, one windowFor(), so
// all three stay in lock-step.

export const PERIODS = [
  { key: 'month',     label: 'เดือนนี้' },
  { key: 'lastmonth', label: 'เดือนที่แล้ว' },
  { key: '1m',        label: '1 เดือน' },
  { key: '6m',        label: '6 เดือน' },
  { key: '1y',        label: '1 ปี' },
  { key: 'all',       label: 'ทั้งหมด' },
]

// ── local date helpers (browser is Bangkok) ──
const pad = (n) => String(n).padStart(2, '0')
export function fmt(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` }
export function today() { return fmt(new Date()) }
export function addDays(s, n) { const d = new Date(s + 'T00:00:00'); d.setDate(d.getDate() + n); return fmt(d) }
export function addMonths(s, n) { const d = new Date(s + 'T00:00:00'); d.setMonth(d.getMonth() + n); return fmt(d) }

/** Inclusive day count between two YYYY-MM-DD strings. */
export function daysBetween(a, b) {
  return Math.round((Date.parse(b + 'T00:00:00') - Date.parse(a + 'T00:00:00')) / 86400000) + 1
}

// Window (current + previous comparison range) for each period.
export function windowFor(period) {
  const end = today()
  if (period === 'month') {
    // This calendar month (1st → last day, so upcoming ops this month count)
    // vs the whole previous calendar month.
    const curStart = end.slice(0, 8) + '01'
    const curEnd   = addDays(addMonths(curStart, 1), -1)
    return { curStart, curEnd, prevStart: addMonths(curStart, -1), prevEnd: addDays(curStart, -1) }
  }
  if (period === 'lastmonth') {
    // The whole previous calendar month vs the month before that.
    const thisMonth = end.slice(0, 8) + '01'
    const curStart  = addMonths(thisMonth, -1)
    const curEnd    = addDays(thisMonth, -1)
    return { curStart, curEnd, prevStart: addMonths(curStart, -1), prevEnd: addDays(curStart, -1) }
  }
  if (period === '1m') {
    const curStart = addDays(end, -29)
    return { curStart, curEnd: end, prevStart: addDays(curStart, -30), prevEnd: addDays(curStart, -1) }
  }
  if (period === '6m') {
    const curStart = addMonths(end, -6)
    return { curStart, curEnd: end, prevStart: addMonths(curStart, -6), prevEnd: addDays(curStart, -1) }
  }
  if (period === '1y') {
    const curStart = addMonths(end, -12)
    return { curStart, curEnd: end, prevStart: addMonths(curStart, -12), prevEnd: addDays(curStart, -1) }
  }
  // all — generous lookback, no comparison
  return { curStart: addMonths(end, -48), curEnd: end, prevStart: null, prevEnd: null }
}
